export const selectMemberProfile = (state) =>
  state.view_members?.selectedMemberProfile;

export const memberTransferLoading = (state) => state.view_members.isLoading;
